module.exports = __webpack_public_path__ + "media/images/landing_page/uzdevumi-5036358194311439bbaf674501cfbb53.webp";